module.exports = __webpack_public_path__ + "static/media/load.be0d9fd5.gif";